import { Vector2d, DirectionLineType } from '../../../../types'

import type { IArrow } from '../../../../backend/IRenderer'

export * from './helper'

// 방향 도형 상태 관리 클래스
export class DirectionStateManager {
  public fixedLines: DirectionLineType[] = [] // 방향선들
  public activeLineIndex: number = 0 // 현재 꺾을(마지막) 방향선 인덱스
  public isDirectionFixed: boolean = false // 방향성이 고정되었는지
  public fixedDirection: (Vector2d & { index: number }) | null = null // 방향성
  public originalArrowHead: {
    // 원본 화살표 헤드
    startX: number
    startY: number
    direction: { x: number; y: number }
  } | null = null
  public isTempArrowMode: boolean = false // 방향성을 설정하는 점선 화살표를 표기하는 모드
  public tempArrow: IArrow | null = null // 방향성을 설정하는 점선 화살표
  public prevPoints: number[] | null = null // 이전 점들
  public lastDirection: (Vector2d & { index: number }) | null = null // 마지막 방향성

  constructor() {
    this.reset()
  }

  reset(): void {
    this.fixedLines = []
    this.activeLineIndex = 0
    this.isDirectionFixed = false
    this.fixedDirection = null
    this.originalArrowHead = null
    this.isTempArrowMode = false
    this.tempArrow = null
    this.prevPoints = null
    this.lastDirection = null
  }

  destroyTempArrow(): void {
    if (this.tempArrow) {
      this.tempArrow.destroy()
      this.tempArrow = null
    }
  }

  enterTempArrowMode(arrowPoints: number[]): void {
    this.prevPoints = [...arrowPoints]
    this.isDirectionFixed = false
    this.fixedDirection = null
    this.fixedLines = []
    this.activeLineIndex = 0
    this.isTempArrowMode = true
  }

  exitTempArrowMode(): void {
    this.destroyTempArrow()
    this.isTempArrowMode = false
    this.prevPoints = null
  }
}
